/**
 * ISO 639-3 Language Codes
 */

// const francToLanguageMap: Record<string, Language> = {

export enum Language {
  English = 'eng',
  MandarinChinese = 'cmn',
  Cantonese = 'yue',
  Spanish = 'spa',
  French = 'fra',
  German = 'deu',
  Japanese = 'jpn',
  Korean = 'kor',
  Portuguese = 'por',
  Italian = 'ita',
  Dutch = 'nld',
  StandardArabic = 'arb',
  Indonesian = 'ind',
  Achinese = 'ace',
  Adangme = 'ada',
  Afrikaans = 'afr',
  AssyrianNeoAramaic = 'aii',
  ToskAlbanian = 'als',
  Amharic = 'amh',
  Armenian = 'hye',
  CentralAymara = 'ayr',
  NorthAzerbaijani = 'azj', // Simplified from multiple entries
  Balinese = 'ban',
  Bambara = 'bam',
  Baoulé = 'bci',
  CentralBikol = 'bcl',
  Belarusian = 'bel',
  BembaZambia = 'bem',
  Bengali = 'ben',
  Bhojpuri = 'bho',
  Bini = 'bin',
  Tibetan = 'bod',
  Bosnian = 'bos', // Simplified from multiple entries
  Bulgarian = 'bul',
  BuluCameroon = 'bum',
  Buginese = 'bug',
  Catalan = 'cat',
  Cebuano = 'ceb',
  Czech = 'ces',
  CentralKurdish = 'ckb',
  Chokwe = 'cjk',
  Danish = 'dan',
  NortheasternDinka = 'dip',
  Dyula = 'dyu',
  StandardEstonian = 'ekk',
  ModernGreek = 'ell', // Simplified from multiple entries
  EasternManinkakan = 'emk',
  Esperanto = 'epo',
  Ewe = 'ewe',
  Finnish = 'fin',
  Fon = 'fon',
  Pular = 'fuf',
  NigerianFulfulde = 'fuv',
  Ga = 'gaa',
  Galician = 'glg',
  Gujarati = 'guj',
  Haitian = 'hat',
  Hausa = 'hau',
  Hebrew = 'heb',
  Hindi = 'hin',
  Hiligaynon = 'hil',
  SouthernQiandongMiao = 'hms',
  HmongNjua = 'hnj',
  Croatian = 'hrv',
  Hungarian = 'hun',
  Ibibio = 'ibb',
  Igbo = 'ibo',
  SichuanYi = 'iii',
  Iloko = 'ilo',
  Javanese = 'jav', // Simplified from multiple entries
  Kannada = 'kan',
  Kabardian = 'kbd',
  Kabiyè = 'kbp',
  Georgian = 'kat',
  Kazakh = 'kaz',
  Makonde = 'kde',
  HalhMongolian = 'khk',
  Khmer = 'khm',
  Kimbundu = 'kmb',
  Kinyarwanda = 'kin',
  Kirghiz = 'kir',
  CentralKanuri = 'knc',
  Koongo = 'kng',
  KomiPermyak = 'koi',
  Lao = 'lao',
  StandardLatvian = 'lvs', // Simplified from multiple entries
  Lingala = 'lin',
  Lithuanian = 'lit',
  LowGerman = 'nds',
  LubaLulua = 'lua',
  Luganda = 'lug',
  Lunda = 'lun',
  Madurese = 'mad',
  Magahi = 'mag',
  Maithili = 'mai',
  Malayalam = 'mal',
  Marathi = 'mar',
  Macedonian = 'mkd',
  Minangkabau = 'min',
  Mossi = 'mos',
  Burmese = 'mya',
  Nepali = 'npi', // Simplified from multiple entries
  CentralNahuatl = 'nhn',
  NorwegianNynorsk = 'nno',
  Ndonga = 'ndo',
  Pedi = 'nso',
  Nyanja = 'nya',
  Nyankole = 'nyn',
  NorwegianBokmål = 'nob',
  Pampanga = 'pam',
  Panjabi = 'pan',
  IranianPersian = 'pes',
  PlateauMalagasy = 'plt',
  Polish = 'pol',
  Russian = 'rus',
  Dari = 'prs',
  NorthernPashto = 'pbu',
  ChimborazoHighlandQuichua = 'qug',
  AyacuchoQuechua = 'quy',
  CuscoQuechua = 'quz',
  BalkanRomani = 'rmn',
  Romanian = 'ron',
  MacedoRomanian = 'rup',
  Rundi = 'run',
  Sango = 'sag',
  Santali = 'sat',
  Scots = 'sco',
  Saraiki = 'skr',
  Slovak = 'slk',
  Slovenian = 'slv',
  Shona = 'sna',
  Soninke = 'snk',
  Somali = 'som',
  SouthernSotho = 'sot',
  Serbian = 'srp', // Simplified from multiple entries
  LogudoreseSardinian = 'src',
  Sukuma = 'suk',
  Sundanese = 'sun',
  Swahili = 'swh', // Simplified from multiple entries
  Swati = 'ssw',
  Swedish = 'swe',
  Tagalog = 'tgl',
  Tajik = 'tgk',
  Tamil = 'tam',
  Tatar = 'tat',
  Telugu = 'tel',
  Timne = 'tem',
  Thai = 'tha',
  Tigrinya = 'tir',
  Tiv = 'tiv',
  TongaZambia = 'toi',
  TokPisin = 'tpi',
  Tsonga = 'tso',
  Tswana = 'tsn',
  Turkmen = 'tuk', // Simplified from multiple entries
  Turkish = 'tur',
  Ukrainian = 'ukr',
  Uighur = 'uig', // Simplified from multiple entries
  Umbundu = 'umb',
  Urdu = 'urd',
  NorthernUzbek = 'uzn', // Simplified from multiple entries
  Venetian = 'vec',
  Venda = 'ven',
  Vietnamese = 'vie',
  Makhuwa = 'vmw',
  WarayPhilippines = 'war',
  Wolof = 'wol',
  Xhosa = 'xho',
  Yao = 'yao',
  EasternYiddish = 'ydd',
  Yoruba = 'yor',
  StandardMoroccanTamazight = 'zgh',
  Malay = 'zlm', // Simplified from multiple entries
  Zulu = 'zul',
  YongbeiZhuang = 'zyb',
}

/**
 * Map from ISO 639-3 code (string) to Language enum member
 */
export const francToLanguageMap: Record<string, Language> = Object.entries(Language).reduce(
  (acc, [name, code]) => {
    // 'name' is the string key (e.g., 'Achinese'), 'code' is the string value (e.g., 'ace')
    // We assert that 'name' is a valid key of the Language enum object type
    // Language[name as keyof typeof Language] accesses the enum member itself (e.g., Language.Achinese)
    acc[code] = Language[name as keyof typeof Language];
    return acc;
  },
  {} as Record<string, Language> // Initialize with an empty object and assert its type
);

/**
 * Display names and flags for languages
 * Note: These are the display names for translation languages, not UI languages
 */
export const LanguageDisplayNames: Record<Language, [string, string]> = {
  [Language.Achinese]: ['Achinese', '🇮🇩'],
  [Language.Adangme]: ['Adangme', '🇬🇭'],
  [Language.Afrikaans]: ['Afrikaans', '🇿🇦'],
  [Language.Russian]: [Language.Russian, '🇷🇺'],
  [Language.AssyrianNeoAramaic]: ['Assyrian Neo-Aramaic', '🇮🇶'],
  [Language.ToskAlbanian]: ['Tosk Albanian', '🇦🇱'],
  [Language.Amharic]: ['Amharic', '🇪🇹'],
  [Language.StandardArabic]: [Language.StandardArabic, '🇸🇦'],
  [Language.Armenian]: ['Armenian', '🇦🇲'],
  [Language.CentralAymara]: ['Central Aymara', '🇧🇴'],
  [Language.NorthAzerbaijani]: ['North Azerbaijani', '🇦🇿'],
  [Language.Balinese]: ['Balinese', '🇮🇩'],
  [Language.Bambara]: ['Bambara', '🇲🇱'],
  [Language.Baoulé]: ['Baoulé', '🇨🇮'],
  [Language.CentralBikol]: ['Central Bikol', '🇵🇭'],
  [Language.Belarusian]: ['Belarusian', '🇧🇾'],
  [Language.BembaZambia]: ['Bemba (Zambia)', '🇿🇲'],
  [Language.Bengali]: ['Bengali', '🇧🇩'],
  [Language.Bhojpuri]: ['Bhojpuri', '🇮🇳'],
  [Language.Bini]: ['Bini', '🇳🇬'],
  [Language.Tibetan]: ['Tibetan', '🇨🇳'],
  [Language.Bosnian]: ['Bosnian', '🇧🇦'],
  [Language.Bulgarian]: ['Bulgarian', '🇧🇬'],
  [Language.BuluCameroon]: ['Bulu (Cameroon)', '🇨🇲'],
  [Language.Buginese]: ['Buginese', '🇮🇩'],
  [Language.Catalan]: ['Catalan', '🇪🇸'],
  [Language.Cebuano]: ['Cebuano', '🇵🇭'],
  [Language.Czech]: ['Czech', '🇨🇿'],
  [Language.CentralKurdish]: ['Central Kurdish', '🇮🇶'],
  [Language.Chokwe]: ['Chokwe', '🇦🇴'],
  [Language.MandarinChinese]: [Language.MandarinChinese, '🇨🇳'],
  [Language.Cantonese]: [Language.Cantonese, '🇭🇰'],
  [Language.Danish]: ['Danish', '🇩🇰'],
  [Language.German]: [Language.German, '🇩🇪'],
  [Language.NortheasternDinka]: ['Northeastern Dinka', '🇸🇸'],
  [Language.Dyula]: ['Dyula', '🇨🇮'],
  [Language.StandardEstonian]: ['Standard Estonian', '🇪🇪'],
  [Language.ModernGreek]: ['Modern Greek', '🇬🇷'],
  [Language.EasternManinkakan]: ['Eastern Maninkakan', '🇬🇳'],
  [Language.English]: [Language.English, '🇺🇸'],
  [Language.Esperanto]: ['Esperanto', '🌍'],
  [Language.Ewe]: ['Ewe', '🇬🇭'],
  [Language.Finnish]: ['Finnish', '🇫🇮'],
  [Language.Fon]: ['Fon', '🇧🇯'],
  [Language.French]: [Language.French, '🇫🇷'],
  [Language.Pular]: ['Pular', '🇬🇳'],
  [Language.NigerianFulfulde]: ['Nigerian Fulfulde', '🇳🇬'],
  [Language.Ga]: ['Ga', '🇬🇭'],
  [Language.Galician]: ['Galician', '🇪🇸'],
  [Language.Gujarati]: ['Gujarati', '🇮🇳'],
  [Language.Haitian]: ['Haitian', '🇭🇹'],
  [Language.Hausa]: ['Hausa', '🇳🇬'],
  [Language.Hebrew]: ['Hebrew', '🇮🇱'],
  [Language.Hindi]: ['Hindi', '🇮🇳'],
  [Language.Hiligaynon]: ['Hiligaynon', '🇵🇭'],
  [Language.SouthernQiandongMiao]: ['Southern Qiandong Miao', '🇨🇳'],
  [Language.HmongNjua]: ['Hmong Njua', '🇱🇦'],
  [Language.Croatian]: ['Croatian', '🇭🇷'],
  [Language.Hungarian]: ['Hungarian', '🇭🇺'],
  [Language.Ibibio]: ['Ibibio', '🇳🇬'],
  [Language.Igbo]: ['Igbo', '🇳🇬'],
  [Language.SichuanYi]: ['Sichuan Yi', '🇨🇳'],
  [Language.Iloko]: ['Iloko', '🇵🇭'],
  [Language.Indonesian]: [Language.Indonesian, '🇮🇩'],
  [Language.Italian]: [Language.Italian, '🇮🇹'],
  [Language.Javanese]: ['Javanese', '🇮🇩'],
  [Language.Japanese]: [Language.Japanese, '🇯🇵'],
  [Language.Kannada]: ['Kannada', '🇮🇳'],
  [Language.Kabardian]: ['Kabardian', '🇷🇺'],
  [Language.Kabiyè]: ['Kabiyè', '🇹🇬'],
  [Language.Georgian]: ['Georgian', '🇬🇪'],
  [Language.Kazakh]: ['Kazakh', '🇰🇿'],
  [Language.Makonde]: ['Makonde', '🇹🇿'],
  [Language.HalhMongolian]: ['Halh Mongolian', '🇲🇳'],
  [Language.Khmer]: ['Khmer', '🇰🇭'],
  [Language.Kimbundu]: ['Kimbundu', '🇦🇴'],
  [Language.Kinyarwanda]: ['Kinyarwanda', '🇷🇼'],
  [Language.Kirghiz]: ['Kirghiz', '🇰🇬'],
  [Language.CentralKanuri]: ['Central Kanuri', '🇳🇬'],
  [Language.Koongo]: ['Koongo', '🇨🇩'],
  [Language.KomiPermyak]: ['Komi-Permyak', '🇷🇺'],
  [Language.Korean]: [Language.Korean, '🇰🇷'],
  [Language.Lao]: ['Lao', '🇱🇦'],
  [Language.StandardLatvian]: ['Standard Latvian', '🇱🇻'],
  [Language.Lingala]: ['Lingala', '🇨🇩'],
  [Language.Lithuanian]: ['Lithuanian', '🇱🇹'],
  [Language.LowGerman]: ['Low German', '🇩🇪'],
  [Language.LubaLulua]: ['Luba-Lulua', '🇨🇩'],
  [Language.Luganda]: ['Ganda', '🇺🇬'],
  [Language.Lunda]: ['Lunda', '🇦🇴'],
  [Language.Madurese]: ['Madurese', '🇮🇩'],
  [Language.Magahi]: ['Magahi', '🇮🇳'],
  [Language.Maithili]: ['Maithili', '🇮🇳'],
  [Language.Malayalam]: ['Malayalam', '🇮🇳'],
  [Language.Marathi]: ['Marathi', '🇮🇳'],
  [Language.Macedonian]: ['Macedonian', '🇲🇰'],
  [Language.Minangkabau]: ['Minangkabau', '🇮🇩'],
  [Language.Mossi]: ['Mossi', '🇧🇫'],
  [Language.Burmese]: ['Burmese', '🇲🇲'],
  [Language.Nepali]: ['Nepali', '🇳🇵'],
  [Language.CentralNahuatl]: ['Central Nahuatl', '🇲🇽'],
  [Language.Dutch]: [Language.Dutch, '🇳🇱'],
  [Language.NorwegianNynorsk]: ['Norwegian Nynorsk', '🇳🇴'],
  [Language.Ndonga]: ['Ndonga', '🇳🇦'],
  [Language.Pedi]: ['Pedi', '🇿🇦'],
  [Language.Nyanja]: ['Nyanja', '🇲🇼'],
  [Language.Nyankole]: ['Nyankole', '🇺🇬'],
  [Language.NorwegianBokmål]: ['Norwegian Bokmål', '🇳🇴'],
  [Language.Pampanga]: ['Pampanga', '🇵🇭'],
  [Language.Panjabi]: ['Panjabi', '🇮🇳'],
  [Language.IranianPersian]: ['Iranian Persian', '🇮🇷'],
  [Language.PlateauMalagasy]: ['Plateau Malagasy', '🇲🇬'],
  [Language.Polish]: ['Polish', '🇵🇱'],
  [Language.Portuguese]: [Language.Portuguese, '🇵🇹'],
  [Language.Dari]: ['Dari', '🇦🇫'],
  [Language.NorthernPashto]: ['Northern Pashto', '🇦🇫'],
  [Language.ChimborazoHighlandQuichua]: ['Chimborazo Highland Quichua', '🇪🇨'],
  [Language.AyacuchoQuechua]: ['Ayacucho Quechua', '🇵🇪'],
  [Language.CuscoQuechua]: ['Cusco Quechua', '🇵🇪'],
  [Language.BalkanRomani]: ['Balkan Romani', '🇷🇴'],
  [Language.Romanian]: ['Romanian', '🇷🇴'],
  [Language.MacedoRomanian]: ['Macedo-Romanian', '🇷🇴'],
  [Language.Rundi]: ['Rundi', '🇧🇮'],
  [Language.Sango]: ['Sango', '🇨🇫'],
  [Language.Santali]: ['Santali', '🇮🇳'],
  [Language.Scots]: ['Scots', '🏴󠁧󠁢󠁳󠁣󠁴󠁿'],
  [Language.Saraiki]: ['Saraiki', '🇵🇰'],
  [Language.Slovak]: ['Slovak', '🇸🇰'],
  [Language.Slovenian]: ['Slovenian', '🇸🇮'],
  [Language.Shona]: ['Shona', '🇿🇼'],
  [Language.Soninke]: ['Soninke', '🇲🇱'],
  [Language.Somali]: ['Somali', '🇸🇴'],
  [Language.SouthernSotho]: ['Southern Sotho', '🇱🇸'],
  [Language.Spanish]: [Language.Spanish, '🇪🇸'],
  [Language.Serbian]: ['Serbian', '🇷🇸'],
  [Language.LogudoreseSardinian]: ['Logudorese Sardinian', '🇮🇹'],
  [Language.Sukuma]: ['Sukuma', '🇹🇿'],
  [Language.Sundanese]: ['Sundanese', '🇮🇩'],
  [Language.Swahili]: ['Swahili', '🇰🇪'],
  [Language.Swati]: ['Swati', '🇸🇿'],
  [Language.Swedish]: ['Swedish', '🇸🇪'],
  [Language.Tagalog]: ['Tagalog', '🇵🇭'],
  [Language.Tajik]: ['Tajik', '🇹🇯'],
  [Language.Tamil]: ['Tamil', '🇮🇳'],
  [Language.Tatar]: ['Tatar', '🇷🇺'],
  [Language.Telugu]: ['Telugu', '🇮🇳'],
  [Language.Timne]: ['Timne', '🇸🇱'],
  [Language.Thai]: ['Thai', '🇹🇭'],
  [Language.Tigrinya]: ['Tigrinya', '🇪🇷'],
  [Language.Tiv]: ['Tiv', '🇳🇬'],
  [Language.TongaZambia]: ['Tonga (Zambia)', '🇿🇲'],
  [Language.TokPisin]: ['Tok Pisin', '🇵🇬'],
  [Language.Tsonga]: ['Tsonga', '🇿🇦'],
  [Language.Tswana]: ['Tswana', '🇧🇼'],
  [Language.Turkmen]: ['Turkmen', '🇹🇲'],
  [Language.Turkish]: ['Turkish', '🇹🇷'],
  [Language.Ukrainian]: ['Ukrainian', '🇺🇦'],
  [Language.Uighur]: ['Uighur', '🇨🇳'],
  [Language.Umbundu]: ['Umbundu', '🇦🇴'],
  [Language.Urdu]: ['Urdu', '🇵🇰'],
  [Language.NorthernUzbek]: ['Northern Uzbek', '🇺🇿'],
  [Language.Venetian]: ['Venetian', '🇮🇹'],
  [Language.Venda]: ['Venda', '🇿🇦'],
  [Language.Vietnamese]: ['Vietnamese', '🇻🇳'],
  [Language.Makhuwa]: ['Makhuwa', '🇲🇿'],
  [Language.WarayPhilippines]: ['Waray (Philippines)', '🇵🇭'],
  [Language.Wolof]: ['Wolof', '🇸🇳'],
  [Language.Xhosa]: ['Xhosa', '🇿🇦'],
  [Language.Yao]: ['Yao', '🇲🇼'],
  [Language.EasternYiddish]: ['Eastern Yiddish', '🇮🇱'],
  [Language.Yoruba]: ['Yoruba', '🇳🇬'],
  [Language.StandardMoroccanTamazight]: ['Standard Moroccan Tamazight', '🇲🇦'],
  [Language.Malay]: ['Malay', '🇲🇾'],
  [Language.Zulu]: ['Zulu', '🇿🇦'],
  [Language.YongbeiZhuang]: ['Yongbei Zhuang', '🇨🇳'],
};


// franc 返回 ISO 639-3 代码，也是 AI assistant 返回语言，需要映射到我们的 Language 枚举
// const francToLanguageMap: Record<string, Language> = {
//   // 中文相关
//   'cmn': Language.Chinese, // 普通话
//   'zho': Language.Chinese, // 中文（通用）
//   'chi': Language.Chinese, // 中文（旧代码）
//   'yue': Language.Chinese, // 粤语
  
//   // 英文
//   'eng': Language.English,
  
//   // 法文
//   'fra': Language.French,
//   'fre': Language.French, // 旧代码
  
//   // 西班牙文
//   'spa': Language.Spanish,
  
//   // 日文
//   'jpn': Language.Japanese,
  
//   // 德文
//   'deu': Language.German,
//   'ger': Language.German, // 旧代码
// };

/**
 * Get a human-readable display name for a language
 */
export function getLanguageDisplayName(language: Language): string {
  const [name] = LanguageDisplayNames[language] || [language, ''];
  return name;
}

/**
 * Get the flag emoji for a language
 */
export function getLanguageFlag(language: Language): string {
  const [, flag] = LanguageDisplayNames[language] || ['', ''];
  return flag;
}

/**
 * Get both name and flag for a language
 */
export function getLanguageDisplayNameWithFlag(language: Language): string {
  const [name, flag] = LanguageDisplayNames[language] || [language, ''];
  return `${flag} ${name}`;
}

/**
 * Translation result from any translation service
 */
export interface TranslationResult {
  originalText: string;
  translatedText: string;
  sourceLanguage: Language;
  targetLanguage: Language;
  confidence?: number;
  timestamp: number;
}

/**
 * Event types that can be emitted by translation services
 */
export enum TranslationEventType {
  TranslationStarted = 'translation-started',
  TranslationUpdated = 'translation-updated', 
  TranslationCompleted = 'translation-completed',
  TranslationError = 'translation-error',
  LanguageDetected = 'language-detected',
  SpeakerChanged = 'speaker-changed',
}

/**
 * Base event interface for translation events
 */
export interface TranslationEvent {
  type: TranslationEventType;
  timestamp: number;
}

/**
 * Event emitted when a translation is started
 */
export interface TranslationStartedEvent extends TranslationEvent {
  type: TranslationEventType.TranslationStarted;
  sourceLanguage?: Language;
  targetLanguage: Language;
}

/**
 * Event emitted when a translation is updated (partial results)
 */
export interface TranslationUpdatedEvent extends TranslationEvent {
  type: TranslationEventType.TranslationUpdated;
  result: TranslationResult;
  isFinal: boolean;
}

/**
 * Event emitted when a translation is completed
 */
export interface TranslationCompletedEvent extends TranslationEvent {
  type: TranslationEventType.TranslationCompleted;
  result: TranslationResult;
}

/**
 * Event emitted when a translation error occurs
 */
export interface TranslationErrorEvent extends TranslationEvent {
  type: TranslationEventType.TranslationError;
  error: Error;
  source: string;
}

/**
 * Event emitted when a language is detected
 */
export interface LanguageDetectedEvent extends TranslationEvent {
  type: TranslationEventType.LanguageDetected;
  language: Language;
  confidence: number;
}

/**
 * Event emitted when a speaker change is detected
 */
export interface SpeakerChangedEvent extends TranslationEvent {
  type: TranslationEventType.SpeakerChanged;
  fromLanguage?: Language;
  toLanguage?: Language;
}

/**
 * Union of all translation event types
 */
export type TranslationEventUnion = 
  | TranslationStartedEvent
  | TranslationUpdatedEvent
  | TranslationCompletedEvent
  | TranslationErrorEvent
  | LanguageDetectedEvent
  | SpeakerChangedEvent;

/**
 * Callback type for translation events
 */
export type TranslationEventCallback = (event: TranslationEventUnion) => void;

// ==================== 语言检测功能 ====================

import { franc } from 'franc';



/**
 * 通用的语言检测函数 - 使用 franc 库进行检测
 * @param text 要检测的文本
 * @param supportedLanguages 支持的语言列表
 * @returns 检测到的语言，如果无法检测则返回 null
 */
export function detectLanguageFromText(text: string, supportedLanguages: Language[]): Language | null {
  if (!text || text.trim() === '') {
    return null;
  }
  
  try {
    // 使用 franc 检测语言
    const detectedLangCode = franc(text, { minLength: 20 });
    
    console.log(`🔍 [detectLanguageFromText] franc 检测结果:`, {
      text: text.substring(0, 100) + (text.length > 100 ? '...' : ''),
      detectedLangCode,
      supportedLanguages
    });
    
    // 如果检测结果是 'und'（未确定），使用备用方法
    if (detectedLangCode === 'und') {
      console.log(`⚠️ [detectLanguageFromText] franc 返回 'und'，使用备用检测`);
      return fallbackLanguageDetection(text, supportedLanguages);
    }
    
    // 将 franc 返回的 ISO 639-3 代码映射到我们的 Language 枚举
    const mappedLanguage = mapFrancCodeToLanguage(detectedLangCode);
    
    // 检查映射的语言是否在支持的语言列表中
    if (mappedLanguage && supportedLanguages.includes(mappedLanguage)) {
      console.log(`✅ [detectLanguageFromText] 成功检测语言:`, {
        francCode: detectedLangCode,
        mappedLanguage,
        isSupported: true
      });
      return mappedLanguage;
    }
    
    console.log(`⚠️ [detectLanguageFromText] 检测到的语言不在支持列表中:`, {
      francCode: detectedLangCode,
      mappedLanguage,
      supportedLanguages
    });
    
    // 如果检测失败或不在支持列表中，使用备用检测方法
    return fallbackLanguageDetection(text, supportedLanguages);
  } catch (error) {
    console.error(`❌ [detectLanguageFromText] franc 检测出错:`, error);
    // 出错时使用备用检测方法
    return fallbackLanguageDetection(text, supportedLanguages);
  }
}

/**
 * 将 franc 的 ISO 639-3 语言代码映射到我们的 Language 枚举
 * @param francCode franc 返回的语言代码
 * @returns 对应的 Language 枚举值，如果无法映射则返回 null
 */
export function mapFrancCodeToLanguage(francCode: string): Language | null {
  
  return francToLanguageMap[francCode] || null;
}

/**
 * 备用语言检测方法（基于字符特征）
 * @param text 要检测的文本
 * @param supportedLanguages 支持的语言列表
 * @returns 检测到的语言，如果无法检测则返回第一个支持的语言或 null
 */
export function fallbackLanguageDetection(text: string, supportedLanguages: Language[]): Language | null {
  // 中文字符检测
  const chineseRegex = /[\u4e00-\u9fff\u3000-\u303f\uff00-\uffef\u3400-\u4dbf]/;
  if (chineseRegex.test(text) && supportedLanguages.includes(Language.MandarinChinese)) {
    return Language.MandarinChinese;
  }
  
  // 日文字符检测（平假名、片假名）
  const japaneseRegex = /[\u3040-\u309f\u30a0-\u30ff]/;
  if (japaneseRegex.test(text) && supportedLanguages.includes(Language.Japanese)) {
    return Language.Japanese;
  }
  
  // 法语特殊字符检测
  const frenchRegex = /[àâäéèêëïîôöùûüÿç]/i;
  if (frenchRegex.test(text) && supportedLanguages.includes(Language.French)) {
    return Language.French;
  }
  
  // 西班牙语特殊字符检测
  const spanishRegex = /[ñáéíóúü¿¡]/i;
  if (spanishRegex.test(text) && supportedLanguages.includes(Language.Spanish)) {
    return Language.Spanish;
  }
  
  // 德语特殊字符检测
  const germanRegex = /[äöüß]/i;
  if (germanRegex.test(text) && supportedLanguages.includes(Language.German)) {
    return Language.German;
  }
  
  // 如果没有检测到特殊字符，且英语在支持列表中，默认为英语
  if (supportedLanguages.includes(Language.English)) {
    return Language.English;
  }
  
  // 如果都没有匹配，返回第一个支持的语言作为默认值
  return supportedLanguages[0] || null;
}

/**
 * 将语言代码映射到 Language 枚举（用于处理 AI 回复中的语言代码前缀）
 * @param langCode 语言代码（如 'en', 'zh-cn' 等）
 * @returns 对应的 Language 枚举值，如果无法映射则返回 null
 */
export function mapLanguageCodeToEnum(langCode: string): Language | null {
  const normalizedCode = langCode.toLowerCase();
  

  return francToLanguageMap[normalizedCode] || null;
}
